/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useContext} from "react";
import {MultiSelectDropDown, MultiSelectOption} from "../../../widgets/MultiSelectDropdown";
import {ID_ALL} from "@app/app-shared/permission";
import {OrganizationsContext} from "../ui/organizations/OrganizationsContext";

type Props = {
    onOrgClicked: (orgId: string) => void
    selected: Set<string>
}

export function SelectOrganization(props: Props) {
    const orgCtx = useContext(OrganizationsContext);
    const optionsList: MultiSelectOption[] = Object.values(orgCtx.organizations).reduce((carry: MultiSelectOption[], org) => {
        if (!org)
            return carry;

        return [...carry, {label: org.name, value: org._id, checked: props.selected.has(org._id)}];
    }, [{label: "All", value: ID_ALL, checked: props.selected.size === 0}]);
    if (optionsList.length <= 2)
        return null

    return <div className={"ll_h_c"}>
        <MultiSelectDropDown
            labels={{main: "Organizations"}}
            options={optionsList}
            onItemClick={value => {
                props.onOrgClicked(value)
            }}
        />
    </div>
}
